import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import Reload from './containers/reload/reload';
import configureStore from './configure-store';
import { i18nSetup } from './helpers/locale';

export default class App {
    constructor(element) {
        i18nSetup();
        // initial state based on selected product that has been passed in query string
        const initialState = {};
        // Initial config
        this.store = configureStore(initialState);

        this.element = element;

        ReactDom.render(
            <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
                <Provider store={this.store}>
                    <Reload />
                </Provider>
            </I18nProvider>,
            document.querySelector(this.element)
        );
    }
}

// This global is required in the index.ejs template
window.App = App;
